module.exports = __webpack_public_path__ + "static/media/nftp-dark-circular.97310506.png";